export const MANAGE_ORDER_LOADING = 'MANAGE_ORDER_LOADING';
export const MANAGE_ORDER_ITEM_LIST = 'MANAGE_ORDER_ITEM_LIST';
export const MANAGE_ORDER_SITE_LIST = 'MANAGE_ORDER_SITE_LIST';
export const MANAGE_ORDER_UPDATE_ITEMS_DATA = 'MANAGE_ORDER_UPDATE_ITEMS_DATA';
export const MANAGE_ORDER_CHECKALL_ITEMS_DATA =
  'MANAGE_ORDER_CHECKALL_ITEMS_DATA';
export const MANAGE_ORDER_ERROR = 'MANAGE_ORDER_ERROR';
export const MANAGE_ORDER_CLEAR_GRID_DATA = 'MANAGE_ORDER_CLEAR_GRID_DATA';
export const FETCH_ALL_SITE_ERROR = 'FETCH_ALL_SITE_ERROR';
export const FETCHING_SITES = 'FETCHING_SITES';
export const MANAGE_ORDER_LOADING_ONCLOSE = 'MANAGE_ORDER_LOADING_ONCLOSE';
export const PRINT_PREVIEW_ERROR = 'PRINT_PREVIEW_ERROR';
export const PRINT_PREVIEW_PROCESS_ORDER_LOADING =
  'PRINT_PREVIEW_PROCESS_ORDER_LOADING';
export const RESET_TABLE_PAGE_FLAG = 'RESET_TABLE_PAGE_FLAG';
export const CLEAR_ALL_ERROR = 'CLEAR_ALL_ERROR';
export const SET_TO_DATE_MIN = 'SET_TO_DATE_MIN';
export const SET_FROM_DATE_MAX = 'SET_FROM_DATE_MAX';



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/state/manageProcessOrder/types.js